import { useQuery } from "@apollo/client/react";
import { Box, IconicButton, Text } from "@nulogy/components";
import DeleteConfirmationModal from "components/common/DeleteConfirmationModal";
import { GridBox6 } from "components/common/EditableListStyledComponents";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import { removeShift } from "hooks/apollo/shift/helpers/handleUpdateShifts";
import { GetAllShifts } from "hooks/apollo/shift/shift.gql";
import useDeleteShift from "hooks/apollo/shift/useDeleteShift";
import useDeleteConfirmationModal from "hooks/state/useDeleteConfirmationModal";
import React, { useState } from "react";
import Uuid from "utils/Uuid";
import NewShift from "./NewShift";
import Shift from "./Shift";

export default function Shifts() {
  const { data, loading } = useQuery(GetAllShifts);
  const [newShiftIds, setNewShiftIds] = useState([]);
  const { open: openModal, data: deleteData } = useDeleteConfirmationModal();
  const deleteShift = useDeleteShift();

  const handleAddNewShift = () => {
    setNewShiftIds([...newShiftIds, Uuid.generate()]);
  };

  const handleRemoveNewShift = (shiftId) => {
    setNewShiftIds(newShiftIds.filter((value) => value !== shiftId));
  };

  const handleDelete = (shift) => {
    openModal(shift);
  };

  const onDelete = (shift) =>
    deleteShift({
      update: (proxy) => {
        removeShift(shift.id, proxy);
      },
      variables: { id: shift.id },
    });

  function renderContent() {
    if (loading) return null;

    const hasShifts = newShiftIds.length > 0 || data.shifts.length > 0;

    const addButtonLabel = "Create a new shift";
    const deleteMessage = `This shift (${deleteData.name}) will be permanently deleted; however, its scheduled blocks will not be impacted.`;

    return (
      <Box width="1140px">
        <DeleteConfirmationModal message={deleteMessage} onDelete={onDelete} title="Delete shift" />
        <IconicButton data-testid="add-button" icon="add" marginBottom="x2" onClick={handleAddNewShift} type="button">
          {addButtonLabel}
        </IconicButton>
        {hasShifts && (
          <Box data-testid="shifts-table">
            <GridBox6>
              <Text>Name</Text>
              <Text>Days</Text>
              <Text>Start time</Text>
              <Text>End time</Text>
            </GridBox6>
            <hr style={{ marginBottom: "0px" }} />
            {newShiftIds.map((newShiftId) => (
              <NewShift key={newShiftId} onRemoveNewShift={handleRemoveNewShift} shiftId={newShiftId} />
            ))}
            {data.shifts.map((shift, index) => (
              <Shift index={index} key={shift.id} onDelete={handleDelete} shift={shift} />
            ))}
          </Box>
        )}
      </Box>
    );
  }

  return (
    <PageWithBreadcrumbs
      className="spec-shifts-index-page"
      description="Create, edit, or delete your site’s shifts on this page."
      title="Shifts"
    >
      {renderContent()}
    </PageWithBreadcrumbs>
  );
}
